import { GroupCategoryResponse, GroupCategoryTrainResponse } from '@modules/libs/graphql/generated/graphql';
import { IGroupTrend, ITrendContent } from '@shared/models/groupTrend';
export class GroupTrendEntityMapper {
  public static toDomain(groupTrend: GroupCategoryTrainResponse): IGroupTrend | any {
    return {
      topContent: this.contentMapper(groupTrend.topContent),
      middleContent: this.contentMapper(groupTrend.middleContent),
      bottomContent: this.contentMapper(groupTrend.bottomContent)
    };
  }
  private static contentMapper(content: GroupCategoryResponse[]): ITrendContent[] {
    return content.map(item => ({
      id: item.id,
      icon: item.imageIconUrl,
      text: item.title,
      color: item.mainColor,
      tooltipText: item.tooltipText,
      slugUrl: item.slugUrl
    }));
  }
}